import { useEffect, useCallback, useRef } from 'react';

import { useFetchUser } from '@shared/hooks';

import useAxios from '@services/api';

export const useLogout = () => {
  const [userData, fetchUser] = useFetchUser();
  const { response, error, issueRequest, loading, statusCode } =
    useAxios<Record<string, never>>();
  const isLoggingOutRef = useRef(false);

  const handleSubmit = useCallback(() => {
    // Предотвращаем множественные вызовы
    if (isLoggingOutRef.current || loading) {
      return;
    }
    
    isLoggingOutRef.current = true;
    void issueRequest({ url: `/auth/logout`, method: 'post' });
  }, [issueRequest, loading]);

  useEffect(() => {
    if (statusCode === 200 && isLoggingOutRef.current) {
      isLoggingOutRef.current = false;
      
      // Устанавливаем флаг выхода
      localStorage.setItem('forceLogout', 'true');
      
      // Очищаем sessionStorage
      sessionStorage.clear();
      
      // Очищаем данные пользователя
      fetchUser();
      
      // Редирект на страницу логина
      setTimeout(() => {
        window.location.href = '/login';
      }, 100);
    } else if (error && isLoggingOutRef.current) {
      isLoggingOutRef.current = false;
      console.error('Logout error:', error);
      // Даже при ошибке пытаемся выйти
      localStorage.setItem('forceLogout', 'true');
      sessionStorage.clear();
      fetchUser();
      setTimeout(() => {
        window.location.href = '/login';
      }, 100);
    }
  }, [statusCode, response, error, fetchUser]);

  return [response, handleSubmit, loading] as const;
};
